var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('result-card',{attrs:{"image":"/img/payment-error.png","title":"Не удалось произвести оплату","note":_vm.reason || _vm.defaultReason,"action-label":"Повторить оплату"},on:{"action":function($event){return _vm.$emit('action')}}})}
var staticRenderFns = []

export { render, staticRenderFns }